<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>添加商品</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="margin-top: 40px;">
        <el-form label-width="80px" ref="model" :model="model">
          <el-form-item label="商品名称" prop="goodName">
            <el-input v-model="model.goodName" auto-complete="off" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品专区" prop="goodType">
            <el-select v-model="model.goodType" placeholder="请选择商品专区" @change="clickType">
                <el-option label="算力专区" value="0"></el-option>
                <el-option label="普通专区" value="1"></el-option>
                <el-option label="本地专区" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品类型" prop="doType">
            <el-select v-model="model.doType" placeholder="请选择商品类型">
                <el-option v-for="(item, index) in userData" :label="item.typeName" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品原价" prop="beforeGoodPrize">
            <el-input v-model="model.beforeGoodPrize" auto-complete="off" placeholder="请输入商品原价"></el-input>
          </el-form-item>
          <el-form-item label="商品价格" prop="goodPrize">
            <el-input v-model="model.goodPrize" auto-complete="off" placeholder="请输入商品价格"></el-input>
          </el-form-item>
          <el-form-item label="商品封面图片(仅支持一张)" label-width="185px" prop="userName">
            <el-upload
                class="upload-demo"
                action="https://www.neww.site:446/admin/adminimg"
                :headers="headersData"
                :on-success="handleSuccess2"
                :on-error="handleError"
                :file-list="fileList2"
                name="test"
                list-type="picture">
                <el-button size="small" type="primary">点击上传商品封面图片</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品图片" prop="userName">
            <el-upload
                class="upload-demo"
                action="https://www.neww.site:446/admin/adminimg"
                :headers="headersData"
                :on-success="handleSuccess"
                :on-error="handleError"
                :file-list="fileList"
                name="test"
                list-type="picture">
                <el-button size="small" type="primary">点击上传商品图片</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品描述" prop="userName">
            <vue-editor v-model="model.goodTitle" useCustomImageHandler @image-added="handleImageAdded"></vue-editor>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" v-if="!pageStutas">
          <el-button size="big" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
        </div>
        <div slot="footer" class="dialog-footer" v-else>
          <el-button size="big" type="primary" :loading="loading" class="title" @click="editForm()">编辑</el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {VueEditor, Quill} from "vue2-editor";
  import { adminOnloadImg, getGoodsClassList, unloadAddGoods } from '../../api/userMG'
  export default {
    name: 'Tinymce',
    components:{
      VueEditor
    },
    data() {
      return {
        loading: false,
        pageStutas: false,
        pageStutas: false,
        model:{
            goodName:'',
            goodType:'',
            doType:'',
            sendScore: 0,
            beforeGoodPrize:'',
            goodPrize:'',
            shareAmount: '',
            needFrozen: '',
            goodImg:[],
            goodImg1:'',
            goodTitle:''
        },
        onloadImgData: [],
        onloadImgData2: [],
        userData: [],
        formInline: {
            page: 1,
            limit: 10,
            belongId: 0
        },
        fileList: [],
        fileList2:[],
        headersData:{
            id:localStorage.getItem('loginId'),
            hash:localStorage.getItem('logintoken')
        },
      }
    },
    created() {
        this.getdata(this.formInline)
        if(this.$route.query.goData) {
            this.pageStutas = true;
            this.model.goodImg = []
            // this.$route.query.goData.goodImg = JSON.parse(this.$route.query.goData.goodImg);
            this.model = this.$route.query.goData;
            console.log(this.model)
        }else{
            this.pageStutas = false;
        }
      
    },
    methods: {
        clickType(e) {
          this.formInline.belongId = e;
          this.getdata(this.formInline);
        },
        getdata(valList) {
            this.loading = true
            getGoodsClassList(valList).then(res => {
                this.loading = false
                if (res.success == false) {
                    this.$message({
                        type: 'info',
                        message: res.msg
                    })
                } else {
                  this.userData = res.data
                }
            })
            .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('请稍后再试！')
            })
        },
        handleImageAdded: function (file, Editor, cursorLocation, reseter) {
          var formData = new FormData();
          formData.append("test", file);
          adminOnloadImg(formData).then(res => {
            if (res.success) {
              let url = res.url;
              Editor.insertEmbed(cursorLocation, "image", "https://www.neww.site:444"+url);
              reseter();
            }
          })
        },
        handleSuccess2(file,fileList) {
            this.model.goodImg1 = '';
            this.fileList2.name = fileList.name;
            this.fileList2.url = "https://www.neww.site:444"+fileList.response.url;
            this.model.goodImg1 = this.fileList2.url;
        },
        handleSuccess(file,fileList) {
            this.model.goodImg = []
            this.fileList.name = fileList.name;
            this.fileList.url = "https://www.neww.site:444"+fileList.response.url;
            this.onloadImgData.push(fileList)
            this.onloadImgData.forEach(item => {
                this.model.goodImg.push("https://www.neww.site:444"+item.response.url)
            })
        },
        handleError(err) {
            console.log(err)
        },
        submitForm() {
            this.loading = true;
            unloadAddGoods(this.model)
            .then(res => {
                this.loading = false
                this.model.goodName = '';
                this.model.goodType = '';
                this.model.doType = '';
                this.model.sendScore = 0;
                this.model.beforeGoodPrize = '';
                this.model.goodPrize = '';
                this.model.shareAmount = '';
                this.model.needFrozen = '';
                this.model.goodImg = [];
                this.model.goodImg1 = '';
                this.model.goodTitle = '';
                this.fileList = [];
                if (res.success) {
                this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                })
                } else {
                this.$message({
                    type: 'info',
                    message: res.msg
                })
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        },
        editForm () {
            this.loading = true;
            unloadAddGoods({goodId:this.model.id,goodName:this.model.goodName,goodType:this.model.goodType,doType:this.model.doType,sendScore:this.model.sendScore,beforeGoodPrize:this.model.beforeGoodPrize,shareAmount:this.model.shareAmount,needFrozen:this.model.needFrozen,goodPrize:this.model.goodPrize,goodImg:this.model.goodImg,goodImg1:this.model.goodImg1,goodTitle:this.model.goodTitle})
            .then(res => {
                this.loading = false
                if (res.success) {
                    this.model.goodName = '';
                    this.model.goodType = '';
                    this.model.doType = '';
                    this.model.sendScore = 0;
                    this.model.beforeGoodPrize = '';
                    this.model.goodPrize = '';
                    this.model.shareAmount = '';
                    this.model.needFrozen = '';
                    this.model.goodImg = [];
                    this.model.goodTitle = '';
                    this.fileList = [];
                    this.$message({
                        type: 'success',
                        message: '数据保存成功！'
                    })
                    this.$router.push({
                        path: './Goods'
                    })
                } else {
                this.$message({
                    type: 'info',
                    message: res.msg
                })
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
            })
        }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .editor-custom-btn-container {
    position: absolute;
    right: 100px;
    top: 100px;
    /*z-index: 2005;*/
  }
  .tinymce-textarea {
    visibility: hidden;
    z-index: -1;
  }
  .fullscreen .editor-custom-btn-container {
    z-index: 10000;
    position: fixed;
  }
  
  .editor-upload-btn {
    display: inline-block;
  }
  .dialog-footer{
    margin-left: 80px;
    margin-top: 40px;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/pay/AddGoods.vue